function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M8 1.5c-2.484 0-4.5 1.872-4.5 4.178C3.5 8.928 8 14.5 8 14.5s4.5-5.572 4.5-8.822C12.5 3.372 10.484 1.5 8 1.5zm0 5.966a1.466 1.466 0 110-2.932 1.466 1.466 0 010 2.932z",
  fill: "#4F4F4F"
});

function SvgMapPinIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), _ref);
}

export default SvgMapPinIcon;